<template>
    <div id="searchOnlineCarsVideoViewport">
        <div id="YoutubeVideoActionBar">
            <div id="YoutubeVideoActionEllementsDiv">
                <div id="backToFiltersButton" @click="closeYouTubeVideo">
                    &lt; Back
                </div>
            </div>
        </div>
        <div id="youTube_video_viewport">
            <div id="player"></div>
        </div>
    </div>
</template>

<script>
    /* global YT */

    export default {
        data () {
            return {
                youTubeOrigin: "",
                protocol: "",
                player: null,
                videoSource: '9EwiMwSt-2Q',
                fastForwardVideo: ""
            }
        },
        created() {
            this.youTubeOrigin = encodeURI(window.location.origin);
            this.protocol = window.location.protocol;
        },
        mounted() {
            this.showYouTubeVideo();
        },
        methods: {
            showYouTubeVideo: function() {
                var youtubeId = this.videoSource;
                
                if(typeof(YT) != 'undefined') {
                this.player = new YT.Player('player', {
                    height: '100%',
                    width: '100%',
                    autoplay:  1,
                    videoId: youtubeId, 
                    playerVars: {
                        'origin': this.youTubeOrigin,                 
                        'controls': 0,
                        'rel': 0,
                        'playsinline': 1
                    },
                    events: {
                        'onReady': this.playYouTubeVideo,
                        'onStateChange': this.playNextOrLoop 
                    }
                });
                }
            },
            playNextOrLoop(event) {
                if(event.data === 0) { 
                    this.closeYouTubeVideo();
                }
            },
            playYouTubeVideo(event){
                event.target.playVideo();
            },
            closeYouTubeVideo() {
                this.$store.commit('closeYouTubeVideo');
            }
        }
    }
</script>

<style>
    #searchOnlineCarsVideoViewport {
        position: absolute;
        height: calc(85 * var(--vh));
        width: calc(100 * var(--vw));
        top: calc(12.5 * var(--vh));
        left: 0;
        background-color: #2B2A2B;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }

    .inmobile #searchOnlineCarsVideoViewport {
        height: calc(83 * var(--vh));
    }

    #youTube_video_viewport {
        height: calc((80 * var(--vh)) - (4 * var(--vh)));
        width: calc((100 * var(--vw)) - (4 * var(--vh)));
    }

    .inmobile #youTube_video_viewport {
        height: calc((78 * var(--vh)) - (4 * var(--vh)));
    }

    #YoutubeVideoActionBar {
        width: 100%;
        height: calc(5 * var(--vh));
        font-family: arial, sans-serif;
        font-size: calc((1 * var(--vw)) + ((var(--vratio) - .5) * 1em));
        font-weight: bolder;
        color: white;
        background: #2B2A2B;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    #YoutubeVideoActionEllementsDiv {
        width: calc(90 * var(--vw));
        height: inherit;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    #closeVideoDisplayButton:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
        opacity: .5;
    }
</style>